import React, { useEffect, useState } from "react";
import Layout1 from "../../Layouts/Layout1";
import PropertyShowcaseCard from "../common/PropertyShowcaseCard/PropertyShowcaseCard";
import PropertySoldCard from "../common/PropertySoldCard/PropertySoldCard";
import PropertyWorthCard from "../common/PropertyWorthCard/PropertyWorthCard";
import FilterScreenModel from "../common/FilterScreenModel/FilterScreenModel";
import searchicon from "../../assets/search.png";
import filter from "../../assets/filter.png";
import heart from "../../assets/heart_icon.png";
import property1 from "../../assets/property-1.png";
import property2 from "../../assets/property-2.png";
import agency3 from "../../assets/agency-3.png";
import agency4 from "../../assets/agency-4.png";
import agent1 from "../../assets/agent-1.png";
import agent2 from "../../assets/agent-2.png";
import { toast } from "react-toastify";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import Savepropertypopup from "../savepropertypopup/savepropertypopup";
import axiosInstance from "../../apiInstances/axiosInstance";
import Loder from "../common/Loder";
import { AuthModal } from "../../models/AuthModal";
import FilterNavTab from "../common/FilterNavTab/FilterNavTab";
import { PropertyCardList } from "../common/PropertyCard/PropertyCard";
import RecentSoldProperties from "../common/RecentSoldProperties/RecentSoldProperties";
import { normalizePropertyList } from "../../utils/normalizePropertyList";
import VerticalAds from "../Adds/VerticalAds";
import LayoutContainer from "../../Layouts/LayoutContainer";
import { PropertyCardSkeletonList } from "../Skeleton/PropertyCardSkeleton";

const RentPropertySearch = () => {
  const search = useLocation().pathname.split("/")?.[3];

  const [IsOpen, setIsOpen] = useState(false);
  const [RentPropertyData, setRentPropertyData] = useState([]);
  const [AuthPopUp, setAuthPopUp] = useState(false);
  const [savepropertypopup, setSavepropertypopup] = useState(false);
  const [Searchindata, setSearchindata] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const onClose = () => setSavepropertypopup(false);
  const [ads, setAds] = useState([]);
  const isAuthanticate = localStorage.getItem("Token");
  const navigate = useNavigate();
  const typePriceBed = [
    {
      name: "Property type",
      id: "Property",
    },
    {
      name: "Price",
      id: "Price",
    },
    {
      name: "Bed",
      id: "Bed",
    },
  ];
  const allpropertyid = RentPropertyData.map((data) => {
    if (data?._id) {
      return data?.id;
    }
    return data.id;
  });

  const [Filter, setFilter] = useState({
    search: "",
    category: "",
    status: "Rent",
    agent: "",
    sort_by: "",
    serachbyaddress: "",
  });
  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };
  let [data] = useSearchParams();
  const encryptedData = data.get("encryptedData");
  // let { encryptedData } = useParams();
  useEffect(() => {
    searchValue();
  }, []);

  const GetAllListingData = async (Filter) => {
    setIsLoading(true);
    await axiosInstance
      .post("Agency/viewAllProperty", {
        // search: Filter?.search,
        // category: Filter?.category,
        status: Filter?.status,
        // agent: Filter?.agent,
        // sort_by: Filter?.sort_by,
      })
      .then((res) => {
        const mydata = res?.data?.data || [];
        if (res?.data?.status) {
          const enriched = mydata.map((obj) => ({
            ...obj,
            agencyImg: agency4,
            agentImg: agent2,
          }));

          const normalized = normalizePropertyList(enriched);

          setIsLoading(false);
          setRentPropertyData(normalized);
          setSearchindata(normalized);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
        setIsLoading(false);
      });
  };

  const searchValue = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    axiosInstance
      .post("/searchByAddress", { key: search, status: "Rent", userId: userData?.id || null })
      .then((res) => {
        const mydata = res?.data?.data || [];
        const normalized = normalizePropertyList(mydata);
        setRentPropertyData(normalized);
        // if (res?.data?.status) {
        //   const newArray = mydata.map((obj, i) => ({
        //     ...obj,
        //     id: mydata?.[i]?.id,
        //     frontPageImg: mydata?.[i]?.frontPageImg,
        //     agencyImg: agency4,
        //     agentImg: agent2,
        //     lead_agent: mydata?.[i]?.lead_agent,
        //     price: mydata?.[i]?.price,
        //     street_address_number: mydata?.[i]?.street_address_number,
        //     street_address_name: mydata?.[i]?.street_address_name,
        //     favourite: false,
        //     bedroomCount: mydata[i]?.Bedrooms,
        //     showerCount: mydata[i]?.Bathrooms,
        //     carCount: `${i + 5}`,
        //     squareCount: "6,580 m2",
        //     appartmentCount: "",
        //     acreageCount: mydata[i]?.property_type,

        //   }));

        //   let newResponse = newArray.map((x) => ({
        //     ...x,
        //     favourite: localStorage.getItem("Saved")?.split(",").includes(x.id),
        //   }));

        //   setBuyPropertyData(newResponse);
        // } else {
        //   toast.error(res?.data?.message);
        // }
      })
      // if (searchValue == "" || searchValue == undefined) {
      //   return toast.error("please fill search value");
      // }
      // let status = "";
      // if (isActive === "Buy") {
      //   status = "Active";
      // } else if (isActive === "Address" || isActive === "Agents") {
      //   status = "";
      // } else {
      //   status = isActive;
      // }

      // const sendData = {
      //   key: status === "" ? searchAddress : searchValue,
      //   status: searchDataPage == "buy" ? "Active" : searchDataPage,
      // };
      // axiosInstance
      //   .post("/searchByAddress", sendData)
      //   .then((res) => {
      //     //console.log("🚀 ~ .then ~ res:", res);
      //     if (res.status == 200) {
      //       setSearchData(JSON.stringify(res?.data?.data));

      //       //console.log(res?.data?.data[0]?.status);

      //       navigate(`/${searchDataPage}`);
      //     } else {
      //       //
      //     }
      //   })
      //   .catch((err) => {
      //     //console.log("err --->", err);
      //   });
      .catch((err) => {
        //console.log("err --->", err);
      });
  };
  //   const searchValue = () => {
  //     axiosInstanceAuth
  //       .post("/searchProperty", encryptedData)
  //       .then((res) => {
  //         const mydata = res?.data?.data;
  //         if (res?.data?.status) {
  //           const newArray = mydata.map((obj, i) => ({
  //             ...obj,
  //             id: mydata?.[i]?.id,
  //             frontPageImg: mydata?.[i]?.frontPageImg,
  //             agencyImg: agency4,
  //             agentImg: agent2,
  //             lead_agent: mydata?.[i]?.lead_agent,
  //             price: mydata?.[i]?.price,
  //             street_address_number: mydata?.[i]?.street_address_number,
  //             street_address_name: mydata?.[i]?.street_address_name,
  //             favourite: false,
  //             bedroomCount: mydata[i]?.Bedrooms,
  //             showerCount: mydata[i]?.Bathrooms,
  //             carCount: `${i + 2}`,
  //             squareCount: "6,580 m2",
  //             appartmentCount: "",

  //           }));

  //           let newResponse = newArray.map((x) => ({
  //             ...x,
  //             favourite: localStorage.getItem("Saved")?.split(",").includes(x.id),
  //           }));

  //           setRentPropertyData(newResponse);
  //         } else {
  //           toast.error(res?.data?.message);
  //         }
  //       })
  //       .catch((err) => {
  //         //console.log("err --->", err);
  //       });
  //   };

  const GetSavedProperty = async (isActive) => {
    await axiosInstanceAuth
      .post("savedProperty", {
        status: isActive,
      })
      .then((res) => {
        const mydata = res?.data?.data;
        if (res?.data?.status) {
          localStorage.setItem(
            "Saved",
            mydata.map((obj, i) => `${mydata?.[i]?._id}`),
          );
        } else {
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };
  const [first, setfirst] = useState("");

  const getid = (value) => {
    setfirst(value);
  };
  //  const savesearch = () => {
  //    axiosInstanceAuth
  //      .post(`SaveSearch?id=${JSON.stringify(allpropertyid)}`)
  //      .then((res) => {
  //        const mydata = res?.data?.data;
  //      })
  //      .catch((err) => {
  //        //console.log(err);
  //      });
  //  };
  const sort = async () => {
    const sendData = { sort_by: Filter?.sort_by, status: Filter?.status };
    await axiosInstanceAuth
      .post(`/sortProperty`, sendData)
      .then((res) => {
        const mydata = res?.data?.data;
        if (res?.data?.status) {
          const newArray = mydata.map((obj, i) => ({
            ...obj,
            id: mydata?.[i]?.id,
            frontPageImg: mydata?.[i]?.frontPageImg,
            agencyImg: agency4,
            agentImg: agent2,
            lead_agent: mydata?.[i]?.lead_agent,
            price: mydata?.[i]?.price,
            street_address_number: mydata?.[i]?.street_address_number,
            street_address_name: mydata?.[i]?.street_address_name,
            favourite: false,
            bedroomCount: mydata[i]?.Bedrooms,
            showerCount: mydata[i]?.Bathrooms,
            carCount: `${i + 2}`,
            squareCount: "6,580 m2",
            appartmentCount: "",
            acreageCount: mydata[i]?.property_type,
            // saleDate: `Sold on ${i + 10} Oct 2022`,
          }));
          // setBuyPropertyData(newArray);

          let newResponse = newArray.map((x) => ({
            ...x,
            favourite: localStorage.getItem("Saved")?.split(",").includes(x.id),
          }));

          setRentPropertyData(newResponse);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };

  const filterData = (searchTerm) => {
    const filteredArray = Searchindata.filter((obj) => {
      const allValue = `${obj.street_address_name
        .trim()
        .toLowerCase()} ${obj.street_address_number.toString()}`;
      searchTerm = searchTerm.toLowerCase();
      // Check if the name or ID contains all characters from the search term
      const searchCharacters = searchTerm.split("");
      return searchCharacters.every((char) => allValue.includes(char));
    });
    setRentPropertyData(filteredArray);
  };

  useEffect(() => {
    if (Filter?.sort_by) {
      sort();
    }
  }, [Filter?.sort_by]);

  return (
    <Layout1>
      <div className="bg-white border-t z-50 shadow-sm">
        {/* <div className="flex flex-row justify-between gap-2 py-3 max-w-6xl mx-auto px-3">
        <div className="w-full xl:w-[40%] flex justify-start items-center  py-3 px-4 cursor-pointer">
          <img
            src={searchicon}
            alt="icon"
            className="w-3 lg:w-4 mr-3 cursor-pointer"
          />
          <input
            type="text"
            name="serachbyaddress"
            placeholder="Search by Address"
            className="w-full text-[#737373] font-medium text-xs md:text-sm lg:text-base outline-none"
            onChange={(e) => {
              // onChangeFilter()
              filterData(e.target.value);
            }}
          />
        </div>
        <div className="flex justify-end items-center gap-2">
          {typePriceBed?.map((item, index) => (
            <div
              className="hidden xl:flex justify-center items-center border border-[#E5E5E5] rounded-[28px] px-3 py-[10px] cursor-pointer"
              key={index}
              onClick={() => {
                setIsOpen(true);
                getid(item.id);
              }}
            >
              <div className="text-[#737373] font-medium text-xs md:text-sm lg:text-base">
                {item.name}
              </div>
            </div>
          ))}
          <div
            className="flex justify-center items-center border border-[#E5E5E5] rounded-[28px] py-[10px] px-3 md:px-7 cursor-pointer"
            onClick={() => {
              setIsOpen(true);
              getid("all");
            }}
          >
            <img
              src={filter}
              alt=""
              className="w-4 lg:w-6 mr-2 cursor-pointer"
            />
            <div className="text-[#737373] font-medium text-xs md:text-sm lg:text-base">
              Filters
            </div>
          </div>
        </div>
      </div> */}
        <FilterNavTab currentTab={"Rent"} dataCount={RentPropertyData?.length} />
      </div>

      {/* ---------- End Filter & Search ---------- */}
      <LayoutContainer>
        <div className="w-full flex flex-col lg:flex-row items-start gap-8 my-10 lg:my-16">
          {/* Content Section */}
          <div className="flex flex-col gap-6 w-full flex-1 min-w-0 lg:max-w-[910px]">

            {/* ---------- End Short by & Save ---------- */}
            {isLoading ? (
              <PropertyCardSkeletonList count={5} />
            ) : (
              <PropertyCardList
                PropertyData={RentPropertyData}
                setPropertyData={setRentPropertyData}
                style="mb-5"
                adsList={ads?.betweenAds}
                browseTo="/rent"
              />
            )}
          </div>
          {/* sidebar section */}
          <div className="hidden sticky top-6 lg:block shrink-0 lg:w-[265px] xl:w-[300px] 2xl:w-[360px]">
            <div className="w-full">
              {/* <PropertyShowcaseCard
                  PropertyData={RentPropertyData}
                  scrollToDiv={scrollToDiv}
                  sendDataToParent={handleDataFromChild}
                /> */}
              <PropertyWorthCard style="my-10" />
              {ads?.verticalAds &&
                ads?.verticalAds.length > 0 &&
                ads?.verticalAds?.map((items, index) => {
                  return (
                    <VerticalAds style="my-10" adsList={items} key={index} />
                  );
                })}
            </div>
          </div>
        </div>
        {/* Talk to broker */}
        {/* <div className="max-w-3xl pr-4 pb-[30px]">
            <TalkToBroker />
          </div> */}
        {/* Enquired section */}
        {/* <div
            id="Enquiry"
            ref={targetDivRef}
            className="max-w-3xl pr-4 pb-[60px]"
          >
            <AgentContactCard AgentData={getUserCardData} />
          </div> */}
      </LayoutContainer>
      {/* Talk to broker */}
      {/* <div className="max-w-3xl pr-4 pb-[30px]">
          <TalkToBroker />
        </div> */}
      {/* Enquired section */}
      {/* <div
          id="Enquiry"
          ref={targetDivRef}
          className="max-w-3xl pr-4 pb-[60px]"
        >
          <AgentContactCard AgentData={getUserCardData} />
        </div> */}

      <RecentSoldProperties />
      {/* ----------------------------popup savesearch-------------- */}
      {savepropertypopup ? (
        <Savepropertypopup allpropertyid={allpropertyid} onClose={onClose} />
      ) : null}

      {/* -----------------popup login-------------------- */}
      {AuthPopUp ? (
        <AuthModal open={AuthPopUp} onClose={() => setAuthPopUp(false)} />
      ) : null}

      {/* ---------- Filter Screen Model ---------- */}

      <FilterScreenModel
        setIsOpen={setIsOpen}
        IsOpen={IsOpen}
        currentTab={"Rent"}
        id={first}
        dataCount={RentPropertyData?.length}
      />
    </Layout1>
  );
};

export default RentPropertySearch;
